import Modal from 'components/Modal';
import InitialSignUpScreen from 'components/InitialSignUpScreen';
import { MemoryRouter, Route, useHistory, useLocation } from '@alltrails/shared/components/ReactRouter';
import LogIn from 'components/LogIn';
import CreateAccount from 'components/CreateAccount';

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
  onSuccess: () => void;
  redirectUrl?: string;
};

function Content({ isOpen, onRequestClose, redirectUrl, onSuccess }: Props) {
  const history = useHistory();
  const location = useLocation();

  const goBack = location.pathname !== '/' ? () => history.push('/') : undefined;

  return (
    <Modal goBack={goBack} isOpen={isOpen} onRequestClose={onRequestClose}>
      <Route path="/" exact>
        <InitialSignUpScreen onSuccess={onSuccess} redirectUrl={redirectUrl} />
      </Route>
      <Route path="/:locale?/login" exact>
        <LogIn onSuccess={onSuccess} redirectUrl={redirectUrl} />
      </Route>
      <Route path="/:locale?/register" exact>
        <CreateAccount onSuccess={onSuccess} redirectUrl={redirectUrl} />
      </Route>
    </Modal>
  );
}

export default function SignupModal({ isOpen, onRequestClose, onSuccess, redirectUrl }: Props) {
  if (isOpen) {
    global.branch?.track('pageview', { signupModalTest: true });
  }

  return (
    <MemoryRouter>
      <Content isOpen={isOpen} onRequestClose={onRequestClose} onSuccess={onSuccess} redirectUrl={redirectUrl} />
    </MemoryRouter>
  );
}
